const MEDIA_URL_PREFIX = '/-/jssmedia'

export const LOYALTY_DEAL_IMAGE_PATH = `${MEDIA_URL_PREFIX}/project/common/static-images/loyaltydeal-icon.svg`
export const NEXT_DEAL_ONLINE_IMAGE_PATH = `${MEDIA_URL_PREFIX}/project/common/static-images/nextdeal-online-icon.svg`
